module.exports = __webpack_public_path__ + "static/ActivatedShop-0b4c0441980afe138b562e85416b4b90.png";